import type { ProductDetailResponse } from "@/src/types/product";
import { apiFetch, API_V2, MOBILE_API } from "./api";

export async function getProductDetails(productId: string, outletId: string) {
  return apiFetch<ProductDetailResponse>(
    `${API_V2}/product/product-details?productId=${productId}&outletId=${outletId}`
  );
}

export interface SearchResult {
  id: string;       // MongoDB _id from grablocal-service-product
  name: string;
  thumbnail?: string;
  mrpPrice?: string;
  sellingPrice?: string;
  stockQuantity?: number;
}

interface RawSearchProduct {
  id: string;
  name: string;
  thumbnail?: string | null;
  mrpPrice?: string;
  sellingPrice?: string;
  stockQuantity?: number;
}

export async function searchProducts(
  query: string,
  outletId: string,
  limit = 8
): Promise<SearchResult[]> {
  const params = new URLSearchParams({ query, outletId, limit: String(limit) });
  // portal-api search-product-in-store now proxies to grablocal-service-product
  // returns MongoDB _id as `id` field — correct for product detail navigation
  const res = await apiFetch<{
    success: boolean;
    data: RawSearchProduct[];
  }>(`${MOBILE_API}/product/search-product-in-store?${params}`);

  const raw = Array.isArray(res.data) ? res.data : [];
  return raw.map((p) => ({
    id: String(p.id),
    name: p.name,
    thumbnail: p.thumbnail ?? undefined,
    mrpPrice: p.mrpPrice,
    sellingPrice: p.sellingPrice,
    stockQuantity: p.stockQuantity,
  }));
}
